import { render } from "./MyAccount.vue?vue&type=template&id=1d758220"
import script from "./MyAccount.vue?vue&type=script&lang=js"
export * from "./MyAccount.vue?vue&type=script&lang=js"

import exportComponent from "/Users/czh/Desktop/czh/yog_website/lada/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__